/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioEntityType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION'
}


export function instanceOfInternalApiScenarioEntityType(value: any): boolean {
    for (const key in InternalApiScenarioEntityType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioEntityType, key)) {
            if (InternalApiScenarioEntityType[key as keyof typeof InternalApiScenarioEntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioEntityTypeFromJSON(json: any): InternalApiScenarioEntityType {
    return InternalApiScenarioEntityTypeFromJSONTyped(json, false);
}

export function InternalApiScenarioEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioEntityType {
    return json as InternalApiScenarioEntityType;
}

export function InternalApiScenarioEntityTypeToJSON(value?: InternalApiScenarioEntityType | null): any {
    return value as any;
}

export function InternalApiScenarioEntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioEntityType {
    return value as InternalApiScenarioEntityType;
}

